function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCancelled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.645,3.684c5.948,0.114 11.439,4.752 12.426,10.667c0.942,5.646 -2.457,11.727 -7.777,13.911c-4.515,1.853 -10.062,0.794 -13.608,-2.588c-3.827,-3.65 -5.033,-9.783 -2.771,-14.61c2.02,-4.309 6.533,-7.287 11.402,-7.38c0.164,-0.001 0.164,-0.001 0.328,0Zm-5.25,20.36c4.339,2.891 11.073,1.193 13.369,-3.734c1.311,-2.811 1.072,-6.259 -0.659,-8.91l-0.026,-0.04c-4.228,4.228 -8.456,8.456 -12.684,12.684Zm4.968,-16.732c-4.072,0.077 -7.873,3.11 -8.783,7.067c-0.554,2.407 -0.093,5.015 1.276,7.112l12.711,-12.643c-0.086,-0.057 -0.172,-0.112 -0.258,-0.166c-1.424,-0.874 -3.071,-1.346 -4.734,-1.371c-0.106,0 -0.106,0 -0.212,0.001Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCancelled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cancelled.70fb48f2e09b54b3fc4275ba6bd111e5.svg";